module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Zdjęcia")]), _vm._v(" "), _c('div', {
    staticClass: "filters"
  }, [_c('el-button', {
    attrs: {
      "type": _vm.showUnaccepted ? 'primary' : 'basic'
    },
    on: {
      "click": function($event) {
        _vm.showUnaccepted = !_vm.showUnaccepted
      }
    }
  }, [_vm._v("\n            Pokaż odrzucone\n        ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": _vm.showAccepted ? 'primary' : 'basic'
    },
    on: {
      "click": function($event) {
        _vm.showAccepted = !_vm.showAccepted
      }
    }
  }, [_vm._v("\n            Pokaż zaakceptowane\n        ")])], 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.previewIsUpdating),
      expression: "previewIsUpdating"
    }],
    staticClass: "list"
  }, _vm._l((_vm.instagramPhotos), function(photo) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tileVisible(photo)),
        expression: "tileVisible(photo)"
      }],
      staticClass: "item"
    }, [_c('img', {
      staticClass: "thumbnail",
      attrs: {
        "src": photo.thumbnail_src,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "photo__buttons"
    }, [_c('el-button', {
      attrs: {
        "size": "small",
        "title": "Akceptuj",
        "type": _vm.photosDict[photo.id] && _vm.photosDict[photo.id].accepted ? 'primary' : 'basic'
      },
      on: {
        "click": function($event) {
          return _vm.changePhotoStatus(photo, true)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-check-circle"
    })]), _vm._v(" "), _c('el-button', {
      attrs: {
        "size": "small",
        "title": "Odrzuć",
        "type": _vm.photosDict[photo.id] && !_vm.photosDict[photo.id].accepted ? 'danger' : 'basic'
      },
      on: {
        "click": function($event) {
          return _vm.changePhotoStatus(photo, false)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])], 1)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9f2ebec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Instagram/PhotosPreview.vue
// module id = 809
// module chunks = 0